import { combineReducers } from 'redux';

import {
  reducer as countriesReducer,
  CountriesState,
} from '@ui/scenes/Countries';
import { reducer as storesReducer, StoresState } from '@ui/scenes/Stores';
import { reducer as managersReducer, ManagersState } from '@ui/scenes/Managers';
import {
  reducer as collectionsReducer,
  CollectionsState,
} from '@ui/scenes/Collections';
import { reducer as regionsReducer, RegionsState } from '@ui/scenes/Regions';
import { reducer as citiesReducer, CitiesState } from '@ui/scenes/Cities';
import {
  reducer as cityStoresReducer,
  CityStoresState,
} from '@ui/scenes/CityStores';
import { StorePageState, reducer as storePageReducer } from '@ui/scenes/Store';
import { RequestsState, reducer as requestsReducer } from '@ui/scenes/Requests';
import {
  EditStoreState,
  reducer as editStoreReducer,
} from '@ui/scenes/EditStore';

import { reducer as authReducer, AuthState } from './auth';
import { reducer as mainReducer, MainState } from '../Main';
import { reducer as metaReducer, MetaState } from './meta';

export interface StoreState {
  auth: AuthState;
  main: MainState;
  countries: CountriesState;
  stores: StoresState;
  meta: MetaState;
  managers: ManagersState;
  collections: CollectionsState;
  regions: RegionsState;
  cities: CitiesState;
  cityStores: CityStoresState;
  storePage: StorePageState;
  requests: RequestsState;
  editStore: EditStoreState;
}

const reducer = combineReducers({
  auth: authReducer,
  main: mainReducer,
  countries: countriesReducer,
  stores: storesReducer,
  meta: metaReducer,
  managers: managersReducer,
  collections: collectionsReducer,
  regions: regionsReducer,
  cities: citiesReducer,
  cityStores: cityStoresReducer,
  storePage: storePageReducer,
  requests: requestsReducer,
  editStore: editStoreReducer,
});

const combinedReducer = (state: StoreState, action: { type: string }): any =>
  reducer(state, action);

export default (
  state: StoreState,
  action: { type: string; actions: any[] },
): any => combinedReducer(state, action);



// WEBPACK FOOTER //
// ./src/store/rootReducer.ts